// Lifecycle status pill, shared by the office catalogue screens and the floor
// lookup card. One badge for every §2/§3 status (product, BOM, routing, cost
// run, UoM, schema, template). The visual tone is grouped so, e.g., every
// "active/released/computed" reads green and every "draft/computing" reads
// neutral, without the caller knowing which entity the status belongs to.
//
// UX-0: re-based onto the §3.5 `StatusChip` primitive (design-system spec) —
// same API, same `data-status` contract, revision-6 rendering.

import { useTranslation } from "react-i18next";
import { enumLabel } from "../lib/enum-label";
import { StatusChip, type ChipVariant } from "./status-chip";

export type CatalogueStatus =
  | "draft"
  | "active"
  | "discontinued"
  | "superseded"
  | "archived"
  | "computing"
  | "computed"
  | "compute_failed"
  | "released"
  | "discarded";

const VARIANT: Record<string, ChipVariant> = {
  draft: "neutral",
  active: "ok",
  released: "ok",
  computed: "ok",
  computing: "neutral",
  superseded: "warn",
  discontinued: "neutral",
  archived: "neutral",
  discarded: "neutral",
  compute_failed: "bad",
};

export function StatusBadge({ status }: { status: string }) {
  const { t } = useTranslation();
  const variant: ChipVariant = VARIANT[status] ?? "neutral";
  return (
    <StatusChip variant={variant} data-status={status}>
      {/* A status with no word yet reads "Other", never the code (design-system §3.9). */}
      {enumLabel(t, "catalogue.status", status)}
    </StatusChip>
  );
}
